import { cloneDeep, forEach } from 'lodash-es';
import {
  BookingNewCtrlStates, IBookingInfoAtTimeExtended,
  IBookingNewCtrl,
  ISectionItem,
  IServiceListItem
} from "app/bookings/new/types/newBooking.types";
import {
  BookingMethods,
  BookingType,
  TimeStatus,
  ISectionMaxOcc,
  IScheduleInterval
} from "app/app.types";
import {
  IBooking,
  IBookingStatus,
  IDiarySchedule,
  IDiaryService,
  ISectionLayoutItem,
  ITableItem,
  IDiaryVenue,
  StatusUnconfirmed,
  SECTION_ANY_ID,
  IServiceLayoutItem,

} from 'shared-types/index';
import TableSelectionService from "external-services/table-selection-service/index";
import {BookingStatusNames} from "app/bookingStatusTypes";
import {BookingValidationItems} from "shared-services/booking-validation-service/bookingValidation.types";
import TableJoinService from "app/services/tableJoin/tableJoin.service";
import {StatusServiceInstance} from 'external-services/status-service';
import {WALKIN_DEFAULT_NAME} from "appRoot/app.constants";
import LocationService from "external-services/location-service/index";
import TelemetryService from "app/services/telemetry/telemetry.service";
import NotesService from "external-services/notes-service/index";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import ManagerService from "external-services/manager-service/manager.service";
import BookingIntervalService from "app/services/bookingInterval/bookingInterval.service";
import MaxOccupancyService, {OVER_MAX} from "app/services/maxOccupancy/maxOccupancy.service";
import BookingLookupService from "external-services/booking-lookup-service/index";
import ScheduleLookupService from 'external-services/schedule-lookup-service/scheduleLookup.service';
import ServicesLookupService from 'shared-services/services-lookup-service';
import TablesLookupService from 'external-services/tables-lookup-service/tablesLookup.service';
import LayoutsService from 'external-services/layouts-service/layouts.service';
import {
  BookingAvailabilityService, CAPACITY_MSG_START, NO_TABLES_MSG
} from 'app/services/LegacyBookingAvailabilityService/index';
import {
  IBookingInfoAtTime, IBookingSubset
} from 'app/services/LegacyBookingAvailabilityService/types';
import DateUtilsService from 'external-services/date-utils-service';
import BookingNormaliseService from 'external-services/booking-normalise-service/bookingNormalise.service';
import {WHOLE_NUMBER_REGEX} from "appRoot/app.constants";

// requiring html templates so that hot reloading works
const template = require('./newBookingDetails.html');
const NS = 'NewBookingDetailsDirective';

const isAndroidOrIOS = LocationService.isIOS() || LocationService.isAndroid();

export default function NewBookingDetails() {
  return {
    restrict: 'E',
    replace: true,
    controllerAs: 'newBookingDetails',
    template,
    controller,
    // no scope object means this component has access to parent's scope via `$scope.bookingNew`
  }
}

enum RunningState {
  PastFromYesterday = 'PastFromYesterday',
  FutureFromTomorrow = 'FutureFromTomorrow',
  SameDay = 'SameDay'
}



interface INewBookingDetailsVM {
  coversBookingIntervals: IScheduleInterval[];
  generalSettings: any;
  $onInit: () => void;
  TimeStatus: {
    available: TimeStatus;
    unavailable: TimeStatus;
  };
  RunningState: {
    PastFromYesterday: RunningState;
    FutureFromTomorrow: RunningState;
    SameDay: RunningState;
  },
  statusOptions: IBookingStatus[];
  loaded: boolean;
  isStandbyListEnabled: boolean;
  minBookingDuration: number;
  selectdTableIds: string[];
  archievedTabledIds?: string[];
  archievedTables?: ITableItem[];
  isManager: boolean;
  maxBookingSize: number;
  serviceId: string;
  bookings: IBooking[];
  tables: any[];
  serviceViewList: IServiceListItem[];
  hasNotes: boolean;
  noteDoc: any;
  notes: any;
  layouts: any[];
  sections: ISectionItem[];
  bookingTimes: IBookingInfoAtTimeExtended[];
  selectFromTablesOptions: ITableItem[];
  isTablesLoading: boolean;
  selectdTableId: string;
  currentServiceState: RunningState;
  isCustomTime: boolean;
  selectedTimeId: number;
  isMultipleSection: boolean;
  showMaxOccupancyMessage: boolean;
  showRemoveWaitList: boolean;
  isAndroidOrIOS: boolean;
  errorTableList: ITableItem[];
  WHOLE_NUMBER_REGEX: string;

  selectTime: (availableTime: IBookingInfoAtTimeExtended, autoSelectTable: boolean) => void;
  addToWaitList: () => void;
  seatNow: () => void;
  checkDuration: () => void;
  handleTableIdsChange: (selectdTableIds: string[], tables: ITableItem[], isManualJoin: boolean) => void;
  onServiceSelected: (serviceId: string) => void;
  handleStandbyBtn: () => void;
  handleWaitListBtn: () => void;
  onBookingTimeChange: (selectedIndex: number, time: string) => void;
  toggleIsCustomTime: () => void;
  dateInteracted: (e: any) => void;
  checkDefaultHasChanged: () => void;
  switchToRepeatBookingTab: () => void;
}

function controller(
  $scope: any, $mdDialog: any, $filter: any,
  bookingsCalulationsService: any, tablesService: any,
  unregister: any
) {
  "ngInject";

  let tStart: number | boolean = performance.now();
  let tDateChange: number | boolean;
  let tTimeChange: number | boolean;
  let tPeopleChange: number | boolean;
  let tSectionChange: number | boolean;
  let tServiceChange: number | boolean;
  let bookingsByTable: any;

  /**
   * No scope object means this component has access to parent's scope via `$scope.bookingNew`
   * @todo: isolate the scope for this component, so it can be debugged more easily. Severity: medium
   */
  const bookingNewCtrl: IBookingNewCtrl = $scope.bookingNew;

  let scheduleDate: Date;
  let lastService: any;
  let lastSelectedTime: any;
  let bookingDefaultPeopleHasChanged = false;
  let defaultPeopleByService = 0;
  let ignoreTimeChangeWatch = false;
  let timeZoneId: any;
  const vm: INewBookingDetailsVM = this;
  let dateChangeTO: any;

  // lifecycle hook
  vm.$onInit = function () {
    vm.errorTableList = [];
    const venue: IDiaryVenue = AdminService.getVenue();
    vm.isStandbyListEnabled = venue.standByList || false;
    timeZoneId = venue.timeZoneId;
    vm.TimeStatus = TimeStatus;
    vm.RunningState = RunningState;
    //-- define public properties
    vm.loaded = false;
    vm.minBookingDuration = 30;
    vm.WHOLE_NUMBER_REGEX = WHOLE_NUMBER_REGEX;

    //-- define public methods
    vm.selectTime = selectTime;
    vm.addToWaitList = addToWaitList;
    vm.seatNow = seatNow;
    vm.checkDuration = checkDuration;
    vm.handleTableIdsChange = handleTableIdsChange;
    vm.onServiceSelected = onServiceSelected;
    vm.handleStandbyBtn = handleStandbyBtn;
    vm.handleWaitListBtn = handleWaitListBtn;
    vm.onBookingTimeChange = onBookingTimeChange;
    vm.toggleIsCustomTime = toggleIsCustomTime;
    vm.dateInteracted = dateInteracted;
    vm.checkDefaultHasChanged = checkDefaultHasChanged;
    vm.switchToRepeatBookingTab = switchToRepeatBookingTab;
    vm.selectdTableIds = [];
    vm.archievedTabledIds = [];
    vm.archievedTables = [];
    vm.isManager = ManagerService.isManager;
    vm.isCustomTime = true;

    vm.selectFromTablesOptions = vm.tables;
    vm.isTablesLoading = false;
    vm.showRemoveWaitList = false;
    vm.isAndroidOrIOS = isAndroidOrIOS;

    vm.statusOptions = StatusServiceInstance.getNewBookingFilteredStatusList(
      bookingNewCtrl.booking.status.name === BookingStatusNames.PendingPayment,
      bookingNewCtrl.booking.status.name === BookingStatusNames.StandbyPending,
      !bookingNewCtrl.isNewBooking
    );

    //-- listen
    const listeners: (() => void)[] = [];
    listeners.push($scope.$watch('bookingNew.bookingDate', dateChange));
    listeners.push($scope.$watch('bookingNew.bookingTime', timeChange));
    listeners.push($scope.$watch('bookingNew.booking.people', peopleChange));
    listeners.push($scope.$watch('bookingNew.booking.duration', bookingChange));
    listeners.push($scope.$watch('bookingNew.booking.preferredSectionId', preferredSectionChange));
    listeners.push($scope.$watch('newBookingDetails.serviceId', serviceChange));
    listeners.push($scope.$watch('bookingNew.tableId', bookingChange));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    const selectedTimeId: number = vm.bookingTimes ? vm.bookingTimes.findIndex(t => t.time === bookingNewCtrl.bookingTime) : 0;
    vm.selectedTimeId = selectedTimeId > -1 ? selectedTimeId : 0;

    getGeneralSettings();
  }


  /**
   * Gets called on key up event to force date to lose focus after a short delay.
   * We must lose focus on `bookingDate` to avoid quick consecutive calls on double digits (NBI-1776).
   */
  function dateInteracted(e: any) {
    // ignore keys if they are not numbers (eg tabs)
    if (isNaN(parseInt(e.key, 10))) {
      return;
    }

    if (dateChangeTO) {
      clearTimeout(dateChangeTO)
      dateChangeTO = null;
    }
    dateChangeTO = setTimeout(() => {
      const dateTimeButton = window.angular.element(document.getElementById('dateTimeButton'));
      dateTimeButton && dateTimeButton.focus();
      dateChangeTO = null;
    }, 800);
  }

  function getMaxBookingSize() {
    const isManager = ManagerService.isManager;
    if (!isManager) {
      if (vm.generalSettings && vm.generalSettings.restrictedMaxBookingSize) {
        vm.maxBookingSize = vm.generalSettings.restrictedMaxBookingSize;
      }
    }
  }

  function getGeneralSettings() {
    GeneralSettingsService.get().then(function (settings: any) {
      vm.generalSettings = settings;
      getMaxBookingSize();
    });
  }

  // move checkDuration logic to bookingNormaliseService UI-172
  function checkDuration() {
    bookingNewCtrl.booking.duration = BookingNormaliseService.checkDuration(bookingNewCtrl.booking.duration, vm.minBookingDuration);
  }

  function checkDefaultHasChanged() {
    // the timeout depends on the delay of the debounce in the html for ng-model="bookingNew.booking.people"
    window.setTimeout(() => {
      bookingDefaultPeopleHasChanged = (defaultPeopleByService != bookingNewCtrl.booking.people);
    }, 500);
  }

  /**
   * The selected service has changed update the available times
   * @param  value
   * @param  oldValue
   */
  async function serviceChange(value: number, oldValue: number) {

    if (vm.serviceId && bookingsByTable && value !== oldValue) {
      tServiceChange = performance.now();
      bookingNewCtrl.service = bookingNewCtrl.schedule.services.find(({_id}) => _id === vm.serviceId);//[Number(vm.serviceId)];
      bookingNewCtrl.booking.serviceId = bookingNewCtrl.service._id;
      updateDuration();
      if (!bookingDefaultPeopleHasChanged && !bookingNewCtrl.isBookingToMove) {
        loadBookingPeople()
      }
      const isBetweenTimes = DateUtilsService.isTimeBetweenTwoTimes(bookingNewCtrl.bookingTime, bookingNewCtrl.service.startTime, bookingNewCtrl.service.endTime);
      if (!isBetweenTimes) {
        ignoreTimeChangeWatch = true; // don't want this to trigger a time change event, as that will be handled in getLayouts
        bookingNewCtrl.bookingTime = bookingNewCtrl.service.startTime; // this will trigger timeChange (unless ignoreTimeChangeWatch is set to true)
        vm.selectedTimeId = 0;
        lastSelectedTime = null; // ensures first time in service is selected (and not the closest time)
      }

      setCurrentServiceState();
      getLayouts();

      // triggers refresh
      // bookingNewCtrl.bookingReactRerender(); // don't think we need this?
    }
  }

  function setCurrentServiceState(): void {
    vm.currentServiceState = ServicesLookupService.getCurrentServiceState(
      bookingNewCtrl.service.startTime,
      bookingNewCtrl.service.endTime,
      timeZoneId
    )
  }

  function preferredSectionChange(value: any, oldValue: any) {
    if (value !== oldValue) {
      bookingNewCtrl.tableId = null;
    }

    tSectionChange = performance.now();
    bookingChange(value, oldValue);

  }

  function peopleChange(value: number, oldValue: number) {
    if (value !== oldValue) {
      tPeopleChange = performance.now();
      updateDuration();
      bookingChange(value, oldValue);
    }
  }

  /**
   * The bookings details have changed update the available times
   * @param  value
   * @param  oldValue
   */
  function bookingChange(value: any, oldValue: any) {
    if (bookingsByTable && value !== oldValue) {
      calculateBookingTimes();
      bookingNewCtrl.updateTabs();
    }
  }

  function loadBookingPeople() {
    // ZERO as pax default is part of the business rule - don't change it (NBI-3195)
    bookingNewCtrl.booking.people = ServicesLookupService.getDefaultServicePax(
      bookingNewCtrl.service.bookingPAX
    );

    defaultPeopleByService = bookingNewCtrl.booking.people;
  }

  function timeChange(value: Date, oldValue: Date) {

    if (ignoreTimeChangeWatch) {
      ignoreTimeChangeWatch = false;
      return;
    }

    if (bookingNewCtrl.bookingTime) {
      tTimeChange = performance.now();
      if (DateUtilsService.isOnSameDate(bookingNewCtrl.bookingDate, bookingNewCtrl.bookingTime)) {
        if (!bookingNewCtrl.service) {
          selectService()
        }
        if (vm.bookings && vm.tables) {
          // calculate booking by table;
          createBookingsByTable();
          // get booking times
          calculateBookingTimes();
        }
      } else {
        bookingNewCtrl.bookingDate = bookingNewCtrl.bookingTime;
        getSchedule();
      }
    }
  }

  function dateChange() {
    tDateChange = performance.now();

    getSchedule();
  }


  function getSchedule(): void {
    lastService = bookingNewCtrl.service;

    // Schedule
    scheduleDate = cloneDeep(bookingNewCtrl.bookingDate);
    if (bookingNewCtrl.bookingTime && DateUtilsService.isTimeSmallerThanDayEnd(bookingNewCtrl.bookingTime)) {
      scheduleDate.setDate(scheduleDate.getDate() - 1);
    }
    scheduleDate.setHours(0);
    scheduleDate.setMinutes(0);
    scheduleDate.setSeconds(0);
    scheduleDate.setMilliseconds(0);
    getNotes();
    ScheduleLookupService.getSchedule(scheduleDate).then((schedule: IDiarySchedule) => {


      bookingNewCtrl.schedule = schedule;
      if (bookingNewCtrl.schedule.services && bookingNewCtrl.schedule.isOpen) {
        // select the appropriate service;
        // const timeNow: Date = DateUtilsService.getVenueTime(timeZoneId);
        // let bookingDate: Date = new Date(bookingNewCtrl.bookingDate.getTime());
        // bookingDate.setMinutes(timeNow.getMinutes());

        // bookingDate.getHours(timeNow.getHours()); // invalid arg

        // bookingDate.setMilliseconds(timeNow.getMilliseconds());
        // bookingNewCtrl.service = bookingNewCtrl.schedule.services[0];

        // if (bookingDate.setHours(0, 0, 0, 0) === timeNow.setHours(0, 0, 0, 0) || bookingNewCtrl.bookingTime) {
        //   if (bookingNewCtrl.bookingTime) {
        //     bookingDate = bookingNewCtrl.bookingTime;
        //   } else {
        //     bookingDate = DateUtilsService.getVenueTime(timeZoneId);
        //   }
        // }

        // build a list of the service that are in use
        const serviceViewList: IServiceListItem[] = ServicesLookupService.buildServiceViewList(
          bookingNewCtrl.schedule.serviceLayouts,
          bookingNewCtrl.schedule.services
        ).serviceViewList as IServiceListItem[];

        // fixes "move booking" not selecting correct service when services overlap
        if (!lastService && !bookingNewCtrl.isNewBooking) {
          lastService = bookingNewCtrl.schedule.services.find((service) => service._id === bookingNewCtrl.booking.serviceId);
        }

        // Setting the first service of the services showing the radio button. Related to the urgent Prod Issue NBI-1870
        if (serviceViewList.length > 0) {
          bookingNewCtrl.service = bookingNewCtrl.schedule.services.find((service) => service._id === serviceViewList[0].service._id);
        }

        vm.serviceViewList = serviceViewList;
        bookingNewCtrl.serviceViewList = serviceViewList;

        let serviceMatch = false;
        if (lastService) {
          const matchedService = vm.serviceViewList.find(({name}) => name === lastService.name);
          if (matchedService) {
            serviceMatch = true;
            vm.serviceId = matchedService.service._id;
            bookingNewCtrl.service = matchedService.service;
          }
        }

        if (!serviceMatch) {
          selectService();
        }
        updateDuration();
        // we only allow this on the first load. ie populate only frist time, dont over write
        // ever again, even if not changed, as they could innfer the entry of default.
        if (vm.loaded != true) {

          if (bookingNewCtrl.booking.bookingRef) {
          } else {

            loadBookingPeople()
          }
        }

        bookingNewCtrl.booking.serviceId = bookingNewCtrl.service._id;
        setCurrentServiceState();

        // Get layouts
        getLayouts();
      } else {
      }
    });
  }
  function updateDuration() {
    const duration = ScheduleLookupService.getDefaultDuration(bookingNewCtrl.service, bookingNewCtrl.booking.people);
    if (bookingNewCtrl.bookingDuration) {
      bookingNewCtrl.booking.duration = Math.min(duration, bookingNewCtrl.bookingDuration);
    } else {
      bookingNewCtrl.booking.duration = duration;
    }
  }
  function getNotes() {
    vm.hasNotes = false;
    NotesService.getNote(scheduleDate).then(function (noteDoc: any) {
      vm.noteDoc = noteDoc;
      vm.notes = noteDoc.note;
      vm.hasNotes = !!noteDoc.note;
    }).catch(function () {
      vm.hasNotes = false;
      vm.noteDoc = {};
    });
  }

  function selectService() {
    let hadevent = false;
    if (bookingNewCtrl.selectedServiceFromHeader?._id) {
      vm.serviceId = bookingNewCtrl.selectedServiceFromHeader._id;
      // @ts-ignore
      bookingNewCtrl.service = bookingNewCtrl.selectedServiceFromHeader;
    } else if (bookingNewCtrl.schedule) {
      let found = false;
      let serviceFound = false;
      let bookingTime: Date = bookingNewCtrl.bookingTime;
      let service: IDiaryService;

      if (!bookingTime) {
        bookingTime = DateUtilsService.getVenueTime(timeZoneId);
      }

      for (let i = bookingNewCtrl.schedule.services.length - 1; i >= 0; i--) {
        service = bookingNewCtrl.schedule.services[i];

        let sectionAllowed = true;
        if (bookingNewCtrl.tableSection) {
          found = service.sectionLayouts.some(sl => sl.sectionId === bookingNewCtrl.tableSection);
          if (!found) {
            sectionAllowed = false;
          }
        }
        // DateUtilsService.isInBetweenDates(bookingTime, bookingNewCtrl.service.startTime, bookingNewCtrl.service.endTime)
        if (DateUtilsService.isInBetweenDates(bookingTime, service.startTime, service.endTime) && sectionAllowed) {

          /**
           * If 'bookingNewCtrl.tableSection' exists, means it was booked via floorplan or timeline, with table specified
           */
          if (bookingNewCtrl.tableSection) {
            const res = ServicesLookupService.checkServiceContainsSection(
              service,
              bookingNewCtrl.tableSection,
              hadevent
            );
            hadevent = res.serviceWasEvent;

            if (!serviceFound && res.serviceFound) {
              serviceFound = res.serviceFound;
              vm.serviceId = service._id;
              bookingNewCtrl.service = service;
            }
          } else {
            /**
             * Otherwise it was booked via the walkin button and no table has yet been specified and we just need to choose the service
             */
            vm.serviceId = service._id;
            bookingNewCtrl.service = service;
            found = true;
          }
        }

      }

      //added a fix
      // if the service is not found they must be in a gap select the next service
      if ((!found) && bookingTime && !hadevent) {
        const res = ServicesLookupService.getNextAvailableService(
          bookingNewCtrl.schedule.services,
          bookingTime,
        )
        if (res) {
          vm.serviceId = res._id;
          bookingNewCtrl.service = res as IDiaryService;
        }
      }
    }
  }


  /**
   * Gets all layout used in the current service
   */
  function getLayouts() {
    if (bookingNewCtrl.service) {
      const layoutsIds: any[] = [];
      for (let i = bookingNewCtrl.service.sectionLayouts.length - 1; i >= 0; i--) {
        layoutsIds.push(bookingNewCtrl.service.sectionLayouts[i].layoutId);
      }
      vm.isTablesLoading = true;
      return LayoutsService.getLayouts(layoutsIds, bookingNewCtrl.bookingDate).then(function (layouts: any[]) {
        vm.layouts = layouts;
        // Get bookings
        return getBookings();
      });
    } else {
      return false;
    }
  }

  /**
   * Gets all bookings for the given date
   */
  function getBookings() {
    if (bookingNewCtrl.schedule) {
      bookingNewCtrl.selectedTime = null;
      return BookingLookupService.getBySchedule(bookingNewCtrl.schedule).then(function (results: { bookings: IBooking[] }) {
        vm.bookings = $filter('orderBy')(results.bookings, 'time');
        // Get tables
        return getTables();
      }).catch(function (err: string) {
        console.error(err);
        bookingNewCtrl.state = BookingNewCtrlStates.ERROR_LOADING;
      });
    }else {
      return null; // To do : horita need to check this
    }
  }

  async function getTables() {
    const {
      tablesList,
      sections,
      preferredSectionId
    } = await TablesLookupService.getTablesByLayouts(
      bookingNewCtrl.service.sectionLayouts,
      bookingNewCtrl.bookingDate,
      bookingNewCtrl.booking.preferredSectionId
    )

    bookingNewCtrl.booking.preferredSectionId = preferredSectionId;
    vm.tables = tablesList;
    bookingNewCtrl.tableList = tablesList;
    createBookingsByTable();
    bookingNewCtrl.selectedTime = null;
    calculateBookingTimes();
    vm.sections = sections;
  }

  function createBookingsByTable() {
    bookingsByTable = BookingAvailabilityService.getBookingsByTable(vm.bookings as IBookingSubset[]);
  }


  function calculateBookingTimes() {

    let orgTime: IBookingInfoAtTimeExtended = cloneDeep(bookingNewCtrl.selectedTime);
    if (lastSelectedTime) {
      orgTime = cloneDeep(lastSelectedTime);
    }

    bookingNewCtrl.selectedTime = null;
    vm.isTablesLoading = false;
    const bookingTimes: IBookingInfoAtTime[] = BookingAvailabilityService.calulateBookingTimes(
      bookingNewCtrl.schedule, bookingNewCtrl.service, vm.layouts,
      bookingNewCtrl.booking.duration as number, bookingNewCtrl.booking.people, vm.tables, bookingsByTable,
      bookingNewCtrl.booking.preferredSectionId, bookingNewCtrl.tableId, false,
      bookingNewCtrl.bookingMethod, true
    );

    bookingNewCtrl.bookingTimes = vm.bookingTimes = bookingTimes;

    if (bookingsByTable && vm.generalSettings.enableMaxOccupancy) {
      vm.coversBookingIntervals = BookingIntervalService.getCoversPerMinuteInterval(cloneDeep(vm.bookingTimes) as unknown as IScheduleInterval[], vm.bookings, vm.sections as unknown as ISectionMaxOcc[]);
    }

    selectNearestTime(bookingNewCtrl.bookingMethod !== BookingMethods.walkin && orgTime
      ? orgTime.time
      : bookingNewCtrl.bookingTime
    );

    vm.loaded = true;
    telemetryTimes();
  }


  function selectNearestTime(_timeToSelect: Date): void {
    if (!_timeToSelect) {
      return;
    }
    let timeToSelect: Date = _timeToSelect;
    timeToSelect.setDate(bookingNewCtrl.bookingDate.getDate());
    timeToSelect.setMonth(bookingNewCtrl.bookingDate.getMonth());
    timeToSelect.setFullYear(bookingNewCtrl.bookingDate.getFullYear());
    // a time has been passed it select the closet interval to that time
    if (vm.bookingTimes.length === 1) {
      // @todo: quick hot fix for services with only 1 time. Need to clean this logic up a bit though. severity: medium
      selectTime(vm.bookingTimes[0], true);
    } else {
      for (let i = 1; i < vm.bookingTimes.length; i++) {
        const timeBefore: IBookingInfoAtTimeExtended = vm.bookingTimes[i - 1];
        const timeAfter: IBookingInfoAtTimeExtended = vm.bookingTimes[i];
        if ($filter('date')(timeToSelect.getTime(), 'h:mma') === $filter('date')(timeAfter.time.getTime(), 'h:mma')) {
          selectTime(timeAfter, true);
          break;
        }

        if (timeToSelect.getTime() < timeAfter.time.getTime()) {
          const diffToBefore: number = Math.abs(timeToSelect.getTime() - timeBefore.time.getTime());
          const diffToAfter: number = Math.abs(timeToSelect.getTime() - timeAfter.time.getTime());
          if (diffToBefore < diffToAfter) {
            selectTime(timeBefore, true);
          } else {
            selectTime(timeAfter, true);
          }
          timeToSelect = null;
          break;
        }
        if (i === vm.bookingTimes.length - 1) {
          selectTime(timeAfter, true);
        }
      }
    }
  }

  function telemetryTimes() {
    const tComplete: number = performance.now();

    if (tStart) {
      TelemetryService.track('newBookingSetUp', [
        ['duration', tComplete - (tStart as number)]
      ]);
      tStart = false;
      tDateChange = false;
      tPeopleChange = false;
      tSectionChange = false;
      tServiceChange = false;
    } else {
      if (tDateChange) {
        TelemetryService.track('newBookingDateChange', [
          ['duration', tComplete - (tDateChange as number)]
        ]);
        tDateChange = false;
      }

      if (tPeopleChange) {
        TelemetryService.track('newBookingTimeChange', [
          ['duration', tComplete - (tPeopleChange as number)]
        ]);
        tPeopleChange = false;
      }
      if (tSectionChange) {
        TelemetryService.track('newBookingSectionChange', [
          ['duration', tComplete - (tSectionChange as number)]
        ]);
        tSectionChange = false;
      }
      if (tServiceChange) {
        TelemetryService.track('newBookingServiceChange', [
          ['duration', tComplete - (tServiceChange as number)]
        ]);
        tServiceChange = false;
      }
    }
  }

  function selectTime(availableTime: IBookingInfoAtTimeExtended, autoSelectTable: boolean) {
    let table: ITableItem;
    let lowestCapacity: number;
    let lowestPriority: number;
    let samePriorityTables: ITableItem[];

    if (bookingNewCtrl.selectedTime) {
      bookingNewCtrl.selectedTime.state = '';
    }

    if (bookingNewCtrl.bookingMethod === BookingMethods.walkin && vm.isCustomTime) {
      availableTime = {
        ...availableTime,
        time: bookingNewCtrl.bookingTime
      };
    }

    bookingNewCtrl.selectedTime = availableTime;
    lastSelectedTime = bookingNewCtrl.selectedTime;

    const {tableSelectionListWithJoins} = TableSelectionService.createTableSectionList(availableTime, vm.tables);
    vm.selectFromTablesOptions = tableSelectionListWithJoins;

    if (bookingNewCtrl.tableId) {

      // select the table the user has asked for
      const tablesIds = vm.selectFromTablesOptions.map(function (t) {
        return t._id;
      });

      const tableIndex: number = tablesIds.indexOf(bookingNewCtrl.tableId);
      if (tableIndex !== -1) {
        table = vm.selectFromTablesOptions[tableIndex];
      }
    } else {

      /**
       * @todo: replace with table-selection-service (shared front end) -> getTableByCapacityAndPriority
       */
      // select the table with the lowest priority and capacity
      const tables: ITableItem[] = $filter('orderBy')(availableTime.vaildTablesAtTime, ['capacity', 'priority']);
      if (tables.length) {
        // get all the tables with same priority
        lowestPriority = tables[0].priority;
        lowestCapacity = tables[0].capacity;
        samePriorityTables = [];
        for (let i = 0; i < tables.length; i++) {
          const t = tables[i];
          if (t.priority === lowestPriority && t.capacity === lowestCapacity) {
            samePriorityTables.push(t);
          } else {
            break;
          }
        }
        // Select a random one
        table = samePriorityTables[Math.floor(Math.random() * samePriorityTables.length)];
      }
    }
    if (!table) {
      /**
       * @todo: replace with table-selection-service (shared front end) -> getTableByCapacityAndPriority
       */
      // select a join
      const tablesJoins: ITableItem[] = $filter('orderBy')(availableTime.vaidJoinsAtTime, ['capacity', 'priority']);
      if (tablesJoins.length) {
        // get all the tables with same priority
        lowestPriority = tablesJoins[0].priority;
        lowestCapacity = tablesJoins[0].capacity;
        samePriorityTables = [];
        for (let j = 0; j < tablesJoins.length; j++) {
          const t1: ITableItem = tablesJoins[j];
          if (t1.priority === lowestPriority && t1.capacity === lowestCapacity) {
            samePriorityTables.push(t1);
          } else {
            break;
          }
        }
        // Select a random one
        table = samePriorityTables[Math.floor(Math.random() * samePriorityTables.length)];
      }
    }

    bookingNewCtrl.selectedTime.table = table;

    if (table) {
      // update the booking with the table
      if (autoSelectTable) {
        bookingNewCtrl.booking.tables = (table.tablesList) ? table.tablesList : [table];
      }

      vm.selectdTableIds = bookingNewCtrl.booking.tables.map(function (table) {
        return table._id;
      });

      if (bookingNewCtrl.bookingMethod !== BookingMethods.walkin) {
        bookingNewCtrl.customer.customerType = undefined
      }
    } else {
      // update the booking with the table
      bookingNewCtrl.booking.tables = [];
      vm.selectdTableIds = [];
    }

    // set the booking time to the selected time
    bookingNewCtrl.booking.time = availableTime.time;

    // set the availableTime to selected
    availableTime.state = 'selected';

    if (bookingNewCtrl.selectedTime.status === TimeStatus.unavailable) {
      setStandbyDefaults();
    }
  }

  function addToWaitList() {
    bookingNewCtrl.booking.tables = [];
    bookingNewCtrl.booking.bookingType = BookingType.WaitList;
    bookingNewCtrl.bookingReactRerender();
    vm.selectdTableIds = [];
    bookingNewCtrl.nextTab(BookingType.WaitList); //BookingType.WaitList
  }

  function seatNow() {
    bookingNewCtrl.updateTabs();
    bookingNewCtrl.nextTab(BookingType.WaitList);
  }


  function handleTableIdsChange(selectedTableIds: string[], tableList: ITableItem[], isManualJoin: boolean) {

    // check if any of the selected tables have problems and put them in errorTableList
    let errorTableList;

    if (selectedTableIds.length === 1 && !selectedTableIds[0].includes('join')) {
      errorTableList = tableList.filter(
        (item) => selectedTableIds.includes(item._id) && !item.valid && item.problemReasons.length > 0
      );
    } else if (selectedTableIds.length) {

      /**
       * If choosing more than 1 table, we can safely assume the selected table on the left table selector (via timeline clicking)
       * is no longer needed and can be set to auto (since a click can only select a single table anyway).
       */
      if (!isManualJoin) {
        bookingNewCtrl.tableId = 'auto';
      }
      if (isManualJoin) {
        // this for filter out the capacity warning message when user select the table manually
        bookingNewCtrl.selectedTime.warningMsgs = bookingNewCtrl.selectedTime.warningMsgs.filter((item)=>
          !item.includes(CAPACITY_MSG_START)
        )
        // this for filter out the no table warning message when user select the table manually
        bookingNewCtrl.selectedTime.errorMgs = bookingNewCtrl.selectedTime.errorMgs.filter((item)=>
          !item.includes( NO_TABLES_MSG)
        )

      }


      // for manual table joins and predefined table joins
      errorTableList = tableList.filter((item) => {
        if (selectedTableIds && item.tables && item.tables.length === selectedTableIds.length) {
          const allTableIdsMatchSelected = item.tables.every(t => selectedTableIds.includes(t));
          if (allTableIdsMatchSelected && item.problemReasons && item.problemReasons.length) {
            return true;
          }
        }
        return false;
      });
    }

    vm.errorTableList = errorTableList;
    vm.selectdTableIds = selectedTableIds;
    vm.selectFromTablesOptions = tableList;

    if (selectedTableIds.length) {
      // if tables selected, no longer a standby or waitlist booking
      bookingNewCtrl.booking.bookingType = BookingType.Booking;
    }

    bookingNewCtrl.booking.isManualJoin = isManualJoin;

    bookingNewCtrl.booking.tables = TableJoinService.convertToManualJoin(selectedTableIds, tableList, isManualJoin);

    bookingNewCtrl.updateTabs();
    setStandbyDefaults();

    // triggers refresh
    bookingNewCtrl.bookingReactRerender();
    bookingNewCtrl.validationChecked([BookingValidationItems.tables, BookingValidationItems.selectedTime]);

    if (bookingNewCtrl.booking.tables.length > 0 && vm.generalSettings.enableMaxOccupancy) {
      let sectionMaxOccupancy = '';
      vm.isMultipleSection = BookingIntervalService.checkIfBookingOverMultipleSections(bookingNewCtrl.booking);
      if (vm.isMultipleSection) {
        let isOverMax = '';
        vm.sections.forEach((section) => {
          if (section._id !== SECTION_ANY_ID && isOverMax !== OVER_MAX) {
            isOverMax = MaxOccupancyService.checkForCovidMaxOccupancy(bookingNewCtrl.booking, vm.coversBookingIntervals, [section], vm.isMultipleSection);
          }
          sectionMaxOccupancy = isOverMax;
        })
      } else {
        sectionMaxOccupancy = MaxOccupancyService.checkForCovidMaxOccupancy(bookingNewCtrl.booking, vm.coversBookingIntervals, vm.sections, vm.isMultipleSection);
      }
      vm.showMaxOccupancyMessage = sectionMaxOccupancy === OVER_MAX;
    }

  }

  function setStandbyDefaults(): void {
    if (bookingNewCtrl.booking.bookingType === BookingType.StandbyList) {
      bookingNewCtrl.booking.status = StatusUnconfirmed;
      bookingNewCtrl.statusName = BookingStatusNames.Unconfirmed;
      bookingNewCtrl.customer.subscribed = false;
    }
  }

  function onServiceSelected(serviceId: string): void {
    vm.serviceId = serviceId;
  }

  /**
   * Toggles bookingType between StandbyList & Booking
   */
  function handleStandbyBtn(): void {
    const wasStandby = bookingNewCtrl.booking.bookingType === BookingType.StandbyList;
    bookingNewCtrl.booking.bookingType = wasStandby ? BookingType.Booking : BookingType.StandbyList;

    const isStandby = !wasStandby;
    if (isStandby) {
      bookingNewCtrl.booking.tables = [];
      bookingNewCtrl.nextTab(bookingNewCtrl.booking.bookingType);
      setStandbyDefaults();
    }

    // triggers refresh
    bookingNewCtrl.bookingReactRerender();

    bookingNewCtrl.validationChecked([BookingValidationItems.staffName, BookingValidationItems.people]);
    bookingNewCtrl.setEmptyCustomer();
    bookingNewCtrl.updateLables();
  }

  /**
   * Toggles bookingType between WaitList & Booking
   */
  function handleWaitListBtn(): void {
    const wasWaitList = bookingNewCtrl.booking.bookingType === BookingType.WaitList;

    // toggles WaitList state
    let isWaitList = !wasWaitList;

    // If showRemoveWaitList is not visible it means that previous state was not WaitList
    if (!vm.showRemoveWaitList) {
      isWaitList = true;
    }

    // sets bookingtype according to isWaitList control
    bookingNewCtrl.booking.bookingType = isWaitList ? BookingType.WaitList : BookingType.Booking;
    vm.showRemoveWaitList = isWaitList;

    if (isWaitList) {
      vm.archievedTabledIds = vm.selectdTableIds;
      vm.archievedTables = bookingNewCtrl.booking.tables;

      bookingNewCtrl.booking.tables = [];
      vm.selectdTableIds = [];
      bookingNewCtrl.nextTab(bookingNewCtrl.booking.bookingType);
    }
    else if (vm.archievedTabledIds.length){
      vm.selectdTableIds = vm.archievedTabledIds;
      bookingNewCtrl.booking.tables = vm.archievedTables;
    }

    // triggers refresh
    bookingNewCtrl.bookingReactRerender();

    bookingNewCtrl.validationChecked(false);

    // empty customer if it's adding to WaitList or removing and an customer hasn't been assigned
    if (isWaitList || (!isWaitList && bookingNewCtrl.customer.firstName == WALKIN_DEFAULT_NAME)) {
      bookingNewCtrl.setEmptyCustomer();
    }
  }

  function onBookingTimeChange(selectedIndex: number, time: string): void {

    let bookingTime: Date;
    if (time) {
      bookingTime = DateUtilsService.setTimeFromString(bookingNewCtrl.booking.time, time);
    } else {
      vm.selectedTimeId = selectedIndex;
      bookingTime = vm.bookingTimes[selectedIndex].time;
    }
    bookingNewCtrl.booking.time = bookingTime;
    bookingNewCtrl.bookingTime = bookingTime;

    // triggers refresh
    bookingNewCtrl.bookingReactRerender();
  }

  function toggleIsCustomTime(): void {
    vm.isCustomTime = !vm.isCustomTime;

    if (vm.isCustomTime) {
      bookingNewCtrl.bookingTime = bookingNewCtrl.booking.time
    } else if (vm.selectedTimeId !== -1) {
      bookingNewCtrl.bookingTime = vm.bookingTimes[vm.selectedTimeId].time;
    }
  }

  function switchToRepeatBookingTab() {
    bookingNewCtrl.openRepeatBookingTab = !bookingNewCtrl.openRepeatBookingTab;
  }

}
